export enum AuthTypeSaga {
  LoginSaga = 'auth/LOGIN_USER',
  LogOutSaga = 'auth/LOGOUT_USER',
}
